import http from "../httpService";
import {getBaseUrl} from "../../config";

// Handle the feature's Persian error messages locally. Keep the shared 401
// handler responsible for expired sessions.
const requestConfig = {
  skipSuccessToast: true,
  validateStatus: status => status >= 200 && status < 600 && status !== 401,
};

async function paymentRequest(request) {
  let response;
  try {
    response = await request;
  } catch (cause) {
    if (cause?.code === "ERR_CANCELED") throw cause;
    const error = new Error(cause?.response?.status === 401
      ? "زمان جلسه شما تمام شده است. لطفاً دوباره وارد شوید."
      : "ارتباط با بخش واریزی‌ها برقرار نشد. دوباره تلاش کنید.");
    error.status = cause?.response?.status;
    throw error;
  }
  if (response?.status >= 200 && response.status < 300) return response.data;
  const error = new Error(response?.data?.message || "ارتباط با بخش واریزی‌ها برقرار نشد. دوباره تلاش کنید.");
  error.status = response?.status;
  error.code = response?.data?.error;
  throw error;
}

export function getManualPayments({page = 1, limit = 20, status = "", personId, destinationAccountId, signal} = {}) {
  const params = new URLSearchParams({page: String(page), limit: String(limit)});
  if (status) params.set("status", status);
  if (personId) params.set("person_id", String(personId));
  if (destinationAccountId) params.set("destination_account_id", String(destinationAccountId));
  return paymentRequest(http.get(`${getBaseUrl()}/manual-payments?${params}`, {...requestConfig, signal}));
}

export function getManualPayment(id, {signal} = {}) {
  return paymentRequest(http.get(`${getBaseUrl()}/manual-payments/${encodeURIComponent(id)}`, {...requestConfig, signal}));
}

export function getPaymentDestinations({signal} = {}) {
  return paymentRequest(http.get(`${getBaseUrl()}/manual-payments/destinations`, {...requestConfig, signal}));
}

export function createManualPayment(data, idempotencyKey) {
  return paymentRequest(http.post(`${getBaseUrl()}/manual-payments`, data, {
    ...requestConfig,
    headers: {"Content-Type": "application/json", "Idempotency-Key": idempotencyKey},
  }));
}

export function reviewManualPayment(id, decision, reason = "") {
  return paymentRequest(http.post(`${getBaseUrl()}/manual-payments/${encodeURIComponent(id)}/review`, {decision, reason}, {
    ...requestConfig,
    headers: {"Content-Type": "application/json"},
  }));
}
